import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function RoleGuard({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  // Employers pending admin approval get redirected out of protected employer routes.
  if (user.role === "employer" && (user.status || "active") !== "active") {
    return <Navigate to="/pending-approval" replace />;
  }
  return children;
}
